/** Validation and comparison functions for sandbox3 */

export function pfNamesEqual(a: string, b: string) {
  return a.trim().toLowerCase() === b.trim().toLowerCase();
}

